import { render } from "./App.vue?vue&type=template&id=0e95a9cd"
import script from "./App.js?vue&type=script&lang=js"
export * from "./App.js?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0e95a9cd&lang=scss"

import exportComponent from "/home/runner/work/korean-handbook/korean-handbook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__